export const isApple = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
